import { create } from "zustand";

interface LayoutStoreIFace {
  showLogoInHeader: any;
  setShowLogoInHeader: (showLogoInHeader: any) => void;
}

const useLayoutStore = create<LayoutStoreIFace>((set) => ({
  showLogoInHeader: true,
  setShowLogoInHeader: (showLogoInHeader) => set({ showLogoInHeader }),
}));

export default useLayoutStore;
